module.exports = __webpack_public_path__ + "static/1.2.A. CAIAN RANDARE 1-793d7e4515881f3de971d5701a963313.jpg";